import React, { useContext, useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import IncompleteReport from "./report/IncompleteReport";
import AllReportsPage from "./report/AllReportsPage";
import Utils from "../../../../Utils";
import { useParams } from "react-router-dom";
import ContextComponent from "../../../../AppContext";
import { utility } from "./report/utility";

const SiteReportsPage = () => {
  const { siteid } = useParams();
  const { setLoadingState } = useContext(ContextComponent);
  const [activeTab, setActiveTab] = useState("incomplete");
  const [siteName, setSiteName] = useState("");

  const tableColumns = utility.tableColumns;
  const tableColumnSchema = utility.tableColumnSchema;

  const handleSiteNameUpdate = (name) => {
    setSiteName(name);
  };

  const getCurrentDateTime = () => {
    return new Date().toISOString().replace(/:/g, "-").replace(/\./g, "-");
  };

  const success = (res, reportType) => {
    // Assuming res contains the CSV data as text
    const csvData = res.data;
    const currentDateTime = getCurrentDateTime();
    const fileName = `${siteName.replace(
      /[()]/g,
      ""
    )}-${reportType}-${currentDateTime}.csv`;

    // Create a BOM (Byte Order Mark) for UTF-8 encoding
    const BOM = "\uFEFF"; // UTF-8 BOM

    // Concatenate the BOM and the CSV data
    const csvWithBOM = BOM + csvData;

    const blob = new Blob([csvWithBOM], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = fileName;

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const fail = (error) => {
    console.log("Download failed", error);
  };

  const exportReports = (siteid, reportType) => {
    Utils.getExportReportsBySiteId({ siteId: siteid, reportType }).then(
      (res) => success(res, reportType),
      fail
    );
  };

  const handleDownload = () => {
    const reportType = activeTab === "incomplete" ? "incomplete" : "complete";
    exportReports(siteid, reportType);
  };

  return (
    <>
      <div className="indi-body-cards-wrapper d-flex w-100">
        <div className="indi-add-card-title">
          <span>
            Reports<span className="indi-site-name-in-header"> {siteName}</span>
          </span>
          <div
            className="indi-body-action"
            role="button"
            onClick={handleDownload}
          >
            Export to Excel
          </div>
        </div>

        {/* TAB view */}
        <div className="indi-add-form-wrapper">
          <Tabs
            activeKey={activeTab}
            onSelect={(k) => setActiveTab(k)}
            className="mb-3"
          >
            <Tab
              eventKey="incomplete"
              title={<span className="indi-tab-title">Incomplete</span>}
            >
              <IncompleteReport
                props={{
                  siteId: siteid,
                  onSiteNameUpdate: handleSiteNameUpdate,
                  tableColumns,
                  tableColumnSchema,
                  setLoadingState,
                }}
              />
            </Tab>
            <Tab
              eventKey="complete"
              title={<span className="indi-tab-title">Complete</span>}
            >
              <AllReportsPage
                props={{
                  siteId: siteid,
                  onSiteNameUpdate: handleSiteNameUpdate,
                  tableColumns,
                  tableColumnSchema,
                  setLoadingState,
                }}
              />
            </Tab>
          </Tabs>
        </div>
      </div>
    </>
  );
};

export default SiteReportsPage;
